import React from 'react';

/**
 * Reusable skeleton loader for service cards in grid layout
 * Used in CategoryServices page
 */
const ServiceCardSkeleton = ({ count = 8 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-xl md:rounded-2xl overflow-hidden border border-gray-200 animate-pulse"
        >
          {/* Image Skeleton */}
          <div className="relative h-52 md:h-52 bg-gray-200">
            <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
          </div>

          {/* Content Skeleton */}
          <div className="p-3 md:p-4 space-y-3">
            {/* Title and Rating */}
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2">
                  <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                </div>
                <div className="h-4 bg-gray-200 rounded w-1/2">
                  <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                </div>
              </div>
              <div className="ml-2 h-4 w-10 bg-gray-200 rounded">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
            </div>

            {/* Vendor Name */}
            <div className="h-3 bg-gray-200 rounded w-2/3">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>

            {/* Location */}
            <div className="h-3 bg-gray-200 rounded w-3/4">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
            </div>

            {/* Price */}
            <div className="pt-2 md:pt-3 border-t border-gray-100">
              <div className="h-4 bg-gray-200 rounded w-1/3">
                <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceCardSkeleton;

